import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorTransfer1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M10.046 17.05a.75.75 0 0 1-1.06-.04l-2.786-3a.75.75 0 0 1 .55-1.26h10.5a.75.75 0 0 1 0 1.5H8.47l1.615 1.74a.75.75 0 0 1-.039 1.06Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm3.014 4.74a.75.75 0 0 0-1.1 1.02l1.616 1.74H6.75a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 .55-1.26l-2.786-3Z"
    />
  </svg>
);
export default SvgTwoColorTransfer1;
